/** Based on VS Code Light+ */

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #000;
	--pce-bg: #fff;
	--pce-widget-border: #bfbfbf;
	--pce-widget-bg: #f8f8f8;
	--pce-widget-color: #444;
	--pce-widget-color-active: #000;
	--pce-widget-color-options: #666;
	--pce-widget-bg-input: #fff;
	--pce-widget-bg-hover: #b8b8b84f;
	--pce-widget-bg-active: #c2dff2;
	--pce-widget-focus: #0077f0;
	--pce-search-match: #ea5c0054;
	--pce-widget-bg-error: #f2dede;
	--pce-widget-error: #be1100;
	--pce-border-highlight: 2px solid #eee;
	--pce-selection-match: #add6ff80;
	--pce-line-number: #53abc6;
	--pce-scrollbar: 0, 0%, 25%;
	--pce-bg-fold: #424242;
	--pce-guide-indent: #3333;
	--pce-ac-icon-class: #d67e00;
	--pce-ac-icon-enum: #d67e00;
	--pce-ac-icon-event: #d67e00;
	--pce-ac-icon-function: #652d90;
	--pce-ac-icon-interface: #007acc;
	--pce-ac-icon-variable: #007acc;
	--pce-ac-match: #0066bf;
	--pce-tabstop: #0a326433;
	--pce-invisibles: #3333;
	--pce-selection: #add6ff;
	color-scheme: light;
}

.match-highlight {
	--pce-bg-highlight: #eee;
}

.pce-match {
	--pce-search-match: #c1adab;
}

.active-line {
	--pce-line-number: #0b216f;
}

.active-indent {
	--pce-guide-indent: #0006;
}

.pce-tooltip {
	color: #333;
}

/* Tokens */
.token.namespace {
	opacity: 0.7;
}

.token.comment,
.token.prolog {
	color: #008000;
}

.token.number,
.token.symbol,
.token.inserted,
.token.unit {
	color: #098658;
}

.token.string,
.token.string-property.property,
.token.char,
.token.deleted {
	color: #a31515;
}

.token.operator,
.token.combinator,
.token.punctuation,
.token.attr-equals,
.token.plain-text,
.token.quantifier.number {
	color: #000;
}

.token.operator.arrow,
.token.keyword,
.token.important,
.token.boolean,
.token.entity,
.token.attr-value,
.token.attr-value:not(.script):not(.style) > .punctuation,
.token.regex-flags {
	color: #0000ff;
}

.token.atrule .token.rule {
	color: #af00db;
}

.token.function {
	color: #795e26;
}

.token.italic {
	font-style: italic;
}

.token.bold,
.token.important {
	font-weight: 700;
}

.token.class-name,
.token.builtin,
.token.maybe-class-name {
	color: #267f99;
}

.token.doctype .name,
.token.property,
.token.anchor,
.token.alternation,
.token.attr-name,
.token.url {
	color: #e50000;
}

.token.variable,
.token.parameter,
.token.literal-property,
.token.atrule {
	color: #001080;
}

.token.doctype,
.token.doctype > .punctuation,
.token.selector,
.token.escape,
.token.tag,
.token.tag > .punctuation,
.token.cdata {
	color: #800000;
}

.token.namespace {
	color: #4ec9b0;
}

.token.constant {
	color: #0070c1;
}

/* Language overrides */

[class*="language-"] {
	color: #001080;
}

.token.regex,
.language-regex,
.token.char-set,
.token.char-class .operator {
	color: #811f3f;
}

.language-markup,
.language-markdown,
.language-md,
.language-html,
.language-xml,
.language-svg,
.language-text,
.language-vue,
.language-svelte,
.language-astro,
.language-css,
.language-scss,
.language-sass,
.token.code.keyword {
	color: #000;
}

.token.color,
.token.blockquote,
.token.list {
	color: #0451a5;
}

.token.bold * {
	color: #000080;
}

.token.important.title *,
.token.important.title,
.token.code.code-snippet {
	color: #800000;
}

.token.url .token.content,
.token.url.string,
.token.regex .punctuation {
	color: #a31515;
}

.language-markdown .token.url,
.token.url-reference .variable,
.token.url-reference .punctuation {
	color: #3b3b3b;
}

/* Key words */

.token.block > .keyword,
.token.keyword.module,
.token.keyword.control-flow,
.token.keyword-if,
.token.keyword-else,
.token.keyword-return,
.token.keyword-switch,
.token.keyword-case,
.token.keyword-default,
.token.keyword-import,
.token.keyword-from,
.token.keyword-export,
.token.keyword-as,
.token.keyword-for,
.token.keyword-while,
.token.keyword-break,
.token.keyword-continue,
.token.keyword-try,
.token.keyword-catch,
.token.keyword-finally,
.token.keyword-throw,
.token.keyword-yield,
.token.keyword-await {
	color: #af00db;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #0431fa;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #319331;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #7b3814;
}

.token.interpolation-punctuation {
	color: #0000ff;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #b9b9b9, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #57575740;
}
